import { ApiResponse } from 'apisauce';

import { ExportJobCreateResult } from '@/Modules/MyFilesModule/shared/types/export-job.type';
import { FinanceApplicationReportTablePayload } from '@/Modules/ReportsModule/FinanceApplicationReport/shared/types/finance-application-report-payload.type';
import { mapQueueExportApiResponse } from '@/shared/utils/queue-export-job.util';
import { ErrorInfo } from '@/shared/interfaces/error-info.interface';
import { FinanceApplicationReportResponseModel } from '@/shared/interfaces/response-model.interface';
import financeApplicationsReportMapper from '@/shared/mappers/finance-applications-report/finance-applications-report.mapper';
import { FinanceApplicationsReportModel } from '@/shared/models/finance-application-report.model';
import { financeApplicationsReportApi } from '@/shared/services/apis/finance-applications-report-apis/finance-applications-report-api.service';
import errorHelper from '@/shared/services/helpers/error-helper/error-helper.service';
import { FinanceApplicationsReportUiModel } from '@/shared/ui-models/finance-application-report.ui-model';

export async function searchFinanceApplicationReport(
  reportPayload: FinanceApplicationReportTablePayload,
  containerName: string
): Promise<FinanceApplicationReportResponseModel<FinanceApplicationsReportUiModel[]> | ErrorInfo> {
  const response: ApiResponse<
    FinanceApplicationReportResponseModel<FinanceApplicationsReportModel[]>,
    ErrorInfo
  > = await financeApplicationsReportApi.searchFinanceApplicationsReport(reportPayload);

  if (response.ok) {
    const { data } = response;
    if (data?.data) {
      return {
        ...data,
        data: financeApplicationsReportMapper.mapToUi(data.data),
        total_count: data.total_count ?? 0,
        totalFinanceAmount: data.totalFinanceAmount ?? 0
      };
    } else {
      const error: ErrorInfo = errorHelper(
        0,
        '',
        containerName,
        financeApplicationsReportApi.searchFinanceApplicationsReport?.name || ''
      );
      return error;
    }
  } else {
    const error: ErrorInfo = errorHelper(
      Number(response.status),
      response.data?.errorCode ? String(response.data.errorCode || '') : response.problem,
      containerName,
      financeApplicationsReportApi.searchFinanceApplicationsReport?.name || ''
    );
    return error;
  }
}

export async function exportFinanceApplicationReport(
  payload: Pick<FinanceApplicationReportTablePayload, 'query' | 'sort'>,
  containerName: string
): Promise<ExportJobCreateResult | ErrorInfo | undefined> {
  const response = await financeApplicationsReportApi.exportFinanceApplicationsReport(payload);
  return mapQueueExportApiResponse(
    response,
    containerName,
    financeApplicationsReportApi.exportFinanceApplicationsReport.name
  );
}
